import React from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";
import CustomActiveShapePieChart from "../charts/CustomActiveShapePieChart";
import DataTile from "../metrics/DataTile";

const TileBRSocialALlTimeBreached= ({props})=>{
    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycleId = myEntity && myEntity.settings && myEntity.settings.last_cycle_id;


    const social = myEntity
        && myEntity.cycles
        && lastCycleId
        && myEntity.cycles[lastCycleId]
        // && !loadingCycleSocial[lastCycleId]
        && myEntity.cycles[lastCycleId].social

    const allTimeTotals = lastCycleId
        && !loadingCycleSocial[lastCycleId]
        && social
        && social.allTimeTotals;

    const numTestsSent = lastCycleId
    && social
    && social.allTimeTotals
        ? social.allTimeTotals.tests
        : null;

    const numTestsBreached = lastCycleId
    && social
    && social.allTimeTotals
        ? social.allTimeTotals.success
        : null;

    const hasSocialTestData = lastCycleId
        // && !loadingCycleSocial[lastCycleId]
        && social
        && allTimeTotals
        && allTimeTotals.tests !== 0;


    const showPieWith = (stateData) => {
        if (stateData && stateData[customerIdToUse] && myEntity
            // && !loadingCycleSocial[lastCycleId]
            )
        {

            try {

                const arrayData = numTestsSent!== 0
                    ?[{name: "Breached", value: numTestsBreached}, {name: "Not Breached", value: numTestsSent - numTestsBreached}]
                    : [];

                return <div
                    className={"animated fadeIn animation-duration-7"}
                    style={{ marginTop: -40, marginBottom: -15 }}
                ><CustomActiveShapePieChart
                    data = {arrayData}
                    loading = {!arrayData}
                /></div>


            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    const valueFunction = (stateData) => {
        return lastCycleId
        && social
        && social.allTimeTotals
            ? social.allTimeTotals.success
            : null;
    }

    return (
        <DataTile
            subTitle="Total Breached"
            tipText={`Number of Breach Events from Spearphishing since Social Engineering began. Breached means that, as a result of spearphishing code execution, we were able to achieve initial access to the recipient's host. Some successfully executed payloads may not cause a breach due to configurations or security controls.`}
            icon={<div
                className={"animated fadeIn animation-duration-7"}
                style={{ marginTop: -40, marginBottom: -15 }}
            ><CustomActiveShapePieChart
                data = {[]}
                // riskBy5={-1}
                loading
            /></div>}
            iconFunction = {showPieWith}
            iconClasses={" "}
            stateName="breachrisk"
            stateElement="portfolios"
            dontFetch
            // forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && social ? false : true}
            valueFunction={valueFunction}
        />
    )

}

export default TileBRSocialALlTimeBreached;